import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PayDateInfoEx, PayrollStartData } from '../../../../models/payroll';

@Component({
  selector: 'manual-payroll-header',
  templateUrl: './manual-payroll-header.component.html',
  styleUrls: ['./manual-payroll-header.component.scss'],
  standalone: false
})
export class ManualPayrollHeaderComponent implements OnChanges {
  @Input() public showCancel: boolean = true;
  @Input() public showConfirm: boolean;
  @Input() public payrollStartData: PayrollStartData;

  @Output() onCancelButton: EventEmitter<any> = new EventEmitter();
  @Output() onConfirmButton: EventEmitter<any> = new EventEmitter();

  public earliestPayDate: PayDateInfoEx;

  constructor(@Inject('env') private env: any) {}

  ngOnChanges(): void {
    if (this.payrollStartData?.ActivePayroll) {
      const location = this.payrollStartData.Locations.find(
        x => x.Id == this.payrollStartData.ActivePayroll.LocationId
      );

      let earliest: PayDateInfoEx = null;
      for (let payDate of location.NextPayDates) {
        if (earliest == null || payDate.TargetPayDate < earliest.TargetPayDate) {
          earliest = payDate;
        }
      }

      this.earliestPayDate = earliest;
    } else if (this.payrollStartData) {
      this.earliestPayDate = this.payrollStartData.Locations[0].NextPayDates?.reduce((a, b) => {
        return new Date(a.ProcessDueDate) < new Date(b.ProcessDueDate) ? a : b;
      });
    }
  }

  //#region Public Methods

  //#endregion

  //#region Private Methods

  //#endregion
}
